'use client';
import React from 'react';
import AnimatedGradientButton from '../shared/AnimatedGradientButton';

const GradientCta = ({
  buttonLink,
  heading,
}: {
  heading?: string;
  buttonLink?: string;
}) => {
  return (
    <section className="flex w-full flex-col items-center justify-center bg-linear-to-b from-[#8875D5] to-[#D64718] px-8 py-16 text-white max-sm:px-6 max-sm:py-[200px]">
      <div className="content-wrapper flex w-full flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center text-center">
          <h3 className="mb-3 text-center font-['Spectral'] text-[24px] leading-[32px] font-medium tracking-[-5%] md:text-[36px] md:leading-[48px]">
            {heading ? heading : 'Need help?'}
          </h3>
          <AnimatedGradientButton
            flatHover={true}
            text="Talk to a nurse"
            href={buttonLink}
            as="anchor"
            theme="orange"
            className="min-w-[180px]"
          />
        </div>
      </div>
    </section>
  );
};

export default GradientCta;
